import React, { useState } from 'react';
import { Pin, Check, X, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { apiClient } from '../../api/client';
import { notifyTrackingChanged } from '../../lib/useMyTracking';

const stop = (e) => e.stopPropagation();

export default function TrackButton({ shortId, tracked, defaultLeverage = 1, testid = `track-btn-${shortId}` }) {
    const [open, setOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [leverage, setLeverage] = useState(defaultLeverage || 1);
    const [busy, setBusy] = useState(false);

    if (!shortId) return null;
    if (tracked) {
        return (
            <span
                data-testid={`${testid}-tracked`}
                className="inline-flex items-center gap-1 text-[10px] font-semibold text-amber-200 bg-amber-500/10 border border-amber-500/40 rounded-sm px-2 py-0.5"
            >
                <Pin className="h-3 w-3" /> Takipte
            </span>
        );
    }

    const submit = async (e) => {
        stop(e);
        setBusy(true);
        try {
            const { data } = await apiClient.post('/tracking', {
                short_id: shortId,
                amount: amount ? Number(amount) : null,
                leverage: leverage ? Number(leverage) : null,
            });
            toast.success(`#${shortId} takibe alındı`, {
                description: data?.telegram_linked
                    ? "Durum değişince Telegram'dan haber gelecek. 'Benim Takibim' panelinde görürsün."
                    : "Telegram bağlı değil — durumu 'Benim Takibim' panelinden izle.",
            });
            setOpen(false);
            setAmount('');
            notifyTrackingChanged();
        } catch (err) {
            const d = err?.response?.data?.detail;
            toast.error(Array.isArray(d) ? 'Kaldıraç 1-125 arası olmalı' : d || 'Takibe alınamadı');
        } finally {
            setBusy(false);
        }
    };

    if (!open) {
        return (
            <button
                type="button"
                data-testid={testid}
                onClick={(e) => {
                    stop(e);
                    setOpen(true);
                }}
                className="inline-flex items-center gap-1 text-[10px] font-semibold text-emerald-100 bg-emerald-600/30 hover:bg-emerald-600/50 border border-emerald-400/50 rounded-sm px-2 py-0.5 transition-colors"
            >
                <Pin className="h-3 w-3" /> Takibe Al
            </button>
        );
    }

    return (
        <span className="inline-flex items-center gap-1" onClick={stop} role="group">
            <input
                type="number"
                min="0"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                onClick={stop}
                onKeyDown={(e) => e.key === 'Enter' && submit(e)}
                placeholder="$ teminat"
                title="Teminat (USD) — isteğe bağlı"
                data-testid={`${testid}-amount`}
                className="h-6 w-20 bg-slate-900 border border-slate-600 rounded-sm px-1.5 text-[10px] font-mono text-slate-100 outline-none focus:border-emerald-400"
            />
            <input
                type="number"
                min="1"
                max="125"
                value={leverage}
                onChange={(e) => setLeverage(e.target.value)}
                onClick={stop}
                onKeyDown={(e) => e.key === 'Enter' && submit(e)}
                title="Kaldıraç (varsayılan: sistemin önerdiği)"
                data-testid={`${testid}-leverage`}
                className="h-6 w-12 bg-slate-900 border border-slate-600 rounded-sm px-1.5 text-[10px] font-mono text-slate-100 outline-none focus:border-emerald-400"
            />
            <span className="text-[10px] text-slate-400">x</span>
            <button
                type="button"
                onClick={submit}
                disabled={busy}
                data-testid={`${testid}-confirm`}
                className="h-6 px-2 inline-flex items-center gap-1 rounded-sm bg-emerald-500 text-slate-950 text-[10px] font-bold hover:bg-emerald-400 disabled:opacity-60"
            >
                {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Check className="h-3 w-3" />} Onayla
            </button>
            <button
                type="button"
                onClick={(e) => {
                    stop(e);
                    setOpen(false);
                }}
                data-testid={`${testid}-cancel`}
                className="h-6 w-6 inline-flex items-center justify-center rounded-sm text-slate-400 hover:text-slate-100 hover:bg-slate-700"
                title="Vazgeç"
            >
                <X className="h-3 w-3" />
            </button>
        </span>
    );
}
